import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { Control, Controller } from 'react-hook-form';

interface ControlledCheckboxProps {
  name: string;
  control: Control<any, any>;
  label: string;
  defaultValue?: boolean;
}

export const ControlledCheckbox: React.FC<ControlledCheckboxProps> = ({ name, control, label, defaultValue }) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue ?? false}
    render={({ field }) => (
      <FormControlLabel
        control={<Checkbox {...field} checked={field.value} onChange={(e) => field.onChange(e.target.checked)} />}
        label={label}
      />
    )}
  />
);
